<div class="pt-2">
  <p-blockUI [blocked]="blocked">
    <div id="center" style="margin-top:260px; margin-left:800px;">
      <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
    </div>
  </p-blockUI>

  <div class="col-12 flex">
    <div class="col-6 ui-md-12 ui-lg-6 border border-primary innerBorder p-0">
      <div class="col-12 flex p-0">
        <div class="col-3">
          <h5 style="color:#1F89CE; font-size: 18px;">
            <strong>Display Reads</strong>
          </h5>
        </div>
        <div class="col-4 text-center">
          <div class="ui-inputgroup">
            <button pButton class="theme-button labelButton" type="button" label="Sequencer"></button>
            <p-dropdown [style]="{'width':'49%', 'maxWidth':'15em','height': '2vw'}" [options]="sequencerOptions"
              [(ngModel)]="selectedSequencer" placeholder="Select" (onChange)="getDataFromBackEnd(false)"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="col-8 flex p-0">
        <div class="col-4 col-offset-1 text-center font-weight-bold" style="width:22%">
          <div class="col-12 p-0">
            Planable Reads :
          </div>
          <div class="col-12 p-0">
            {{abbreviateNumber(totalReads)}}
          </div>
        </div>
        <div class="col-4 col-offset-1 text-center font-weight-bold" style="width:17%">
          <div class="col-12 p-0">
            On hold reads :
          </div>
          <div class="col-12 p-0">
            {{abbreviateNumber(onholdReads)}}
          </div>
        </div>
        <div class="col-3 text-center font-weight-bold" style="width:27%">
          <div class="col-12 p-0">
            Sel. Reads :
          </div>
          <div class="col-12 p-0">
            {{abbreviateNumber(selectedReads)}}
          </div>
        </div>
      </div>
      <div class="col-12 flex">

        <div class="col-1 p-0 sourceBlock">
          <div *ngFor="let flowCellBlock of flowCellBlocks" [ngStyle]="getFlowCellStyle(flowCellBlock)">
            <div style="font-size: 9px;font-weight: bold;width: 76%;float: left;text-align: right;padding-top: 5%;">
              {{flowCellBlock.name}}</div>
            <div style="width: 22%;float: right;"><em [class]="flowCellBlock.icon"></em></div>
          </div>
        </div>
        <div class="col-2 border border-dark p-0 sourceBlock" style="width:20%">
          <div *ngFor="let readBlock of sourceReadBlocks" [ngStyle]="getStyleOfBlock(readBlock)">
            <em [class]="readBlock.icon" style="margin-left: 46%;"></em>
          </div>
        </div>
        <div class="col-4">
          <label class="col-10 switchLabel">Read modes</label>
          <div class="col-10 border border-dark p-0 switcherTable">
            <p-table [value]="backUpBlocks" [(selection)]="targetReadBlocks" (onRowSelect)="switcherTableRowSelect($event)"
              (onRowUnselect)="switcherTableRowUnselect($event)">
              <ng-template pTemplate="body" let-rowData>
                <tr [pSelectableRow]="rowData" [ngStyle]="getRowStyle(rowData)">
                  <td style="width:23%" class="text-center">
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                  </td>
                  <td style="width:77%">
                    {{rowData.name}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <label class="col-10 switchLabel" style="padding-top: 20px;">Constraint Types</label>
          <div class="col-10  p-0 constraintType">
            <p-multiSelect [options]="exclusiveOptions" [showHeader]="false" [filter]="false"
              (onChange)="onExclusiveRowSelect($event)" [(ngModel)]="selectedConstraintType"
              [style]="{'width':'200px','margin-top': '3px'}">
              <ng-template let-item pTemplate="selectedItem">
                <span style="vertical-align:middle">{{item.label}}</span>
              </ng-template>
              <ng-template let-status pTemplate="item">
                {{status.label}}
              </ng-template>
            </p-multiSelect>
          </div>

          <label class="col-10 switchLabel">Constraint IDs</label>
          <div class="col-10  p-0 constraintID">
            <p-multiSelect [options]="constrainIdOptions" [showHeader]="false" (onChange)="onConstraintID($event)"
              [filter]="false" [(ngModel)]="selectedConstraintID"
              [style]="{'width':'200px','margin-top': '3px','height': '35px'}">
              <ng-template let-item pTemplate="selectedItem">
                {{item.label}}
              </ng-template>
            </p-multiSelect>
          </div>

        </div>
        <div class="col-2 border border-dark p-0 targetBlock" style="width: 20%;">
          <div *ngFor="let readBlock of selectedBlocks" [ngStyle]="getStyleOfBlock(readBlock)">
            <em [class]="readBlock.icon" style="margin-left: 46%;"></em>
          </div>
        </div>
        <div class="col-1  p-0 targetBlock">
          <div *ngFor="let flowCellBlock of flowCellBlocks" [ngStyle]="getFlowCellStyle(flowCellBlock)">
            <div style="width: 17%;float: left;"><em [class]="flowCellBlock.icon"></em></div>
            <div style="font-size: 9px;font-weight: bold;width: 80%;float: right;text-align: left;padding-top: 5%;">
              {{flowCellBlock.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6 ui-md-12 ui-lg-6 border border-primary innerBorder p-0">
      <p-confirmDialog></p-confirmDialog>
      <div class="col-12">
        <h5 style="color:#1F89CE; font-size: 18px;">
          <strong>Lane Usage by Due Date</strong>
        </h5>
      </div>
      <div class="col-12 flex p-0">
        <div class="col-4 ml-2">
          <div class="ui-inputgroup text-center">
            <button pButton class="theme-button labelButton" type="button" label="Flowcell"></button>
            <p-dropdown [style]="{'width':'9em', 'maxWidth':'15em', 'height':'2vw'}" [options]="flowCellOptions"
              optionLabel="flowCellName" (onChange)="constructLanes(selectedFlowCell)" placeholder="Select Flowcell"
              [disabled]="isFlowCellSelectionDisabled()"></p-dropdown>
          </div>
        </div>
        <div class="col-5 col-offset-2 text-right">
          <button pButton label="Calculate" (click)="deleteIPU()" [disabled]="isCalculateDisabled()" style="width: 40%;"
            class="buttonsRound mb-0 mt-0"></button>
        </div>
      </div>

      <div class="col-12 laneContainer" *ngIf="selectedFlowCell">
        <!-- For lanes -->
        <div *ngFor="let lane of lanes; let i = index">
          <div class="col-12 p-0">
            <div class="col-9 ml-2 pb-0" id="{{'laneHeader_'+i}}">
              <div class="col-2 p-0 font-weight-bold">
                {{lane.laneName}}
              </div>
              <div class="col-5 p-0 text-center">
                <div class="ui-inputgroup">
                  <label class="font-weight-bold">Const. ID :</label>
                  <p-dropdown class="ml-1" [options]="constraintGroupedList"
                    [style]="{'width':'10em', 'maxWidth':'10em'}" [group]="true" [(ngModel)]='lane.constraintIdChooser'
                    placeholder="select" (onChange)="assignConstraintIdAndType($event, lane)"></p-dropdown>
                </div>
              </div>
              <div class="col-5 p-0 text-right">
                <label class="font-weight-bold">PhiX :</label>
                <p-spinner size="10" [step]="0.1" [min]="0" [max]="100" [(ngModel)]="lane.phiXPercentage"
                  (onBlur)="changePhixBlockInLane(lane)" (onChange)="changePhixBlockInLane(lane)"></p-spinner>
                <label class="font-weight-bold">%</label>
              </div>
            </div>
          </div>

          <div class="col-12 p-0">
            <div class="col-9 ml-2 p-0 laneBlockContainer lane" id="{{'lane_'+i}}">
              <div *ngFor="let laneBlock of lane.laneBlocks" style="display: inline-block;" class="laneBlock"
                [ngStyle]="getLaneBlockStyle(laneBlock)">
              </div>
            </div>
            <div class="col-2 ml-2 p-0 lane">
              <div class="col-12 p-0 text-right font-weight-bold">
                {{abbreviateNumber(lane.occupiedCapacity)}}
              </div>
              <div class="col-12 p-0 text-right font-weight-bold">
                {{lane.occupiedPercentage}} %
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-12 remainingContainer" *ngIf="selectedFlowCell">
        <!-- For remaining -->
        <div class="col-12 ml-2 pb-0 font-weight-bold">
          Remaining
        </div>
        <div class="col-12 p-0">
          <div class="col-9 ml-2 p-0 laneBlockContainer lane" style="height: 9vh;">
            <div *ngFor="let laneBlock of remainingLane.laneBlocks" style="display: inline-block;height: 8.90vh;"
              class="laneBlock" [ngStyle]="getLaneBlockStyle(laneBlock)">
            </div>
          </div>
          <div class="col-2 ml-2 p-0 lane" [ngStyle]="getRemainingNumberStyle()">
            <div class="col-12 p-0 text-right font-weight-bold">
              {{getRemainingCapacity()}}
            </div>
            <div class="col-12 p-0 text-right font-weight-bold">
              {{getRemainingPercentage()}}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 pt-0  legendContainer" *ngIf="selectedFlowCell">
        <div class="col-6 ml-2 ui-md-6 ui-lg-3 p-0">
          <div class="col-12 ui-md-3 ui-lg-3 p-0">
            <div class="legendBox legendPhix">

            </div>
          </div>
          <div class="col-12 ui-md-9 ui-lg-9 p-0">
            PhiX
          </div>
        </div>
        <div class="col-6 ui-md-6 ui-lg-3 p-0">
          <div class="col-12 ui-md-3 ui-lg-3 p-0">
            <div class="legendBox legendOverdue">

            </div>
          </div>
          <div class="col-12 ui-md-9 ui-lg-9 p-0">
            Overdue
          </div>
        </div>
        <div class="col-6 ui-md-6 ui-lg-3 p-0">
          <div class="col-12 ui-md-3 ui-lg-3 p-0">
            <div class="legendBox legendDueless">

            </div>
          </div>
          <div class="col-12 ui-md-9 ui-lg-9 p-0">
            Due in &#60;=5
          </div>
        </div>
        <div class="col-6 ui-md-6 ui-lg-3 p-0" style="width: 20%;">
          <div class="col-12 ui-md-3 ui-lg-3 p-0">
            <div class="legendBox legendDuemore">

            </div>
          </div>
          <div class="col-12 ui-md-9 ui-lg-9 p-0">
            Due in &#62;5
          </div>
        </div>
      </div>

      <div class="col-12  pb-0" *ngIf="selectedFlowCell">
        <div class="col-3 p-0">
          <button pButton label="Equalize" icon="fa fa-balance-scale" class="buttonsRound" (click)="equiliseLanes()"
            [disabled]="disablePublishRun() || (lanes && lanes.length <2)"></button>
        </div>
        <div class="col-3 p-0">
          <button pButton label="Publish" icon="fa fa-plus" (click)="publishRun()" class="buttonsRound"
            [disabled]="disablePublishRun()"></button>
        </div>
        <div class="col-3 p-0">
          <button pButton label="Discard" icon="fa fa-trash-o" (click)="discardPlan()" class="buttonsRound"
            [disabled]="disablePublishRun()"></button>
        </div>
        <div class="col-3 p-0">
          <button pButton label="Export" icon="fa fa-file-excel-o" (click)="exportPlan()" class="buttonsRound"
            [disabled]="disableExportRun()"></button>
        </div>
      </div>

      <div class="col-12 text-center text-danger font-weight-bold" *ngIf="!selectedFlowCell">
        Select libraries for flowcell selection and lane information to appear
      </div>

      <div class="col-12 mt-2 text-center text-danger font-weight-bold"
        *ngIf="!selectedFlowCell && selectedSequencer && (!flowCellOptions || flowCellOptions.length == 0) && targetReadBlocks && targetReadBlocks.length > 1">
        No flowcell configured for your selection
      </div>


    </div>
  </div>
</div>